import React, { useEffect, useState } from "react";

import InputField from "../../../../common/InputField";
import TextCapsule from "../../../../common/TextCapsule";
import * as Yup from "yup";

import { Typography, Box, Grid } from "@mui/material";
import { Formik, Form } from "formik";
import { LinkButton, SecondaryButton } from "../../../../common/Buttons";
import {
  getHealthcareProxy,
  postHealthcareProxy,
} from "../../../../services/documentServices";
import { toast } from "react-hot-toast";

import "../../../components.scss";
import "../../../../common/styles/colors.scss";
import "./healthcare-proxy.scss";
import {
  FormHeading,
  getKeyFromText,
  getUserIdFromLocalStorage,
  setStepStatus,
} from "../../../../utils/Utilities";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Circles } from "react-loader-spinner";

const answerList = [
  {
    id: 1,
    name: "Yes",
  },
  {
    id: 2,
    name: "No",
  },
];
const ReplacementAttorney = ({ handleSkip, next, setButtonDisabled }) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [initialValues, setInitialValues] = useState({
    name: "",
    dateOfBirth: "",
    address: "",
    email: "",
    phone: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [selectedProperties, setSelectedProperties] = useState(answerList[0]);
  const validate = Yup.object({
    name: Yup.string().max(50, t("max-50-characters")).nullable(),
    email: Yup.string().email(t("Must-be-ValidEmail")).nullable(),
    dateOfBirth: Yup.string().nullable(),
    address: Yup.string().max(50, t("max-50-characters")).nullable(),
    phone: Yup.number(t("must-be-number"))
      .min(0, t("must-be-positive"))
      .test(
        "len",
        t("less-than-15"),
        (val) => !val || (val && val.toString().length <= 15)
      )
      .nullable()
      .typeError(t("must-be-number")),
  });

  const handleClickOnList = (elem) => {
    setSelectedProperties(elem);
  };
  async function fetchData() {
    setIsLoading(true);
    try {
      const result = await getHealthcareProxy(id);
      if (result?.success && result?.payLoad) {
        setData(result.payLoad);
        if (result.payLoad.replacementAttorney !== null) {
          const { dateOfBirth, ...rest } = result.payLoad.replacementAttorney;
          setInitialValues({ ...rest, dateOfBirth: dateOfBirth?.slice(0, 10) });
          setSelectedProperties(
            result.payLoad.replacementAttorney?.isAppointed
              ? answerList[0]
              : answerList[1]
          );
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    fetchData();
  }, []);
  const handleSubmit = async (values) => {
    setButtonDisabled(true);
    const {
      stepStatus,
      replacementAttorneyId,
      healthProxyId,
      dateOfBirth,
      ...rest
    } = values;
    const payload = {
      ...data,
      replacementAttorney: {
        ...rest,
        replacementAttorneyId,
        healthProxyId,
        dateOfBirth: dateOfBirth === "" ? null : dateOfBirth,
        stepStatus: setStepStatus(dateOfBirth, { ...rest }),
        isAppointed: selectedProperties.id === 1,
      },
    };
    const result = await postHealthcareProxy(payload, id);
    if (result?.success) {
      next();
    }
    setButtonDisabled(false);
  };
  const handleDateOfBirthKeyDown = (event) => {
    event.preventDefault();
  };
  return (
    <div className="replacement-attorney-container documents-card-height documents-card-height summary-table">
      {isLoading ? (
        <Box component="div" className="loader-container">
          <Circles color="#dfc8db" height={80} width={80} />
        </Box>
      ) : (
        <Box component="div" width="60%">
          <FormHeading variant="h4" color="color.magentaDark1">
            {t("replacement-attorney-heading")}
          </FormHeading>
          <Box component="div">
            <Typography varient="p">
              {t("replacement-attorney-text")}
            </Typography>
            <Box component="div" className="attorney-section">
              {answerList.map((elem) => {
                return (
                  <TextCapsule
                    key={elem.id}
                    title={t(getKeyFromText(elem.name))}
                    click={() => handleClickOnList(elem)}
                    width="50%"
                    minWidth="auto"
                    padding="10px 0px"
                    textAlign="center"
                    fontSize="14px"
                    borderRadius="15px"
                    bgColor={
                      selectedProperties.id === elem.id
                        ? "color.magentaLight2"
                        : "color.lightGrey"
                    }
                    color={
                      selectedProperties.id === elem.id
                        ? "color.black"
                        : "color.dimGrey"
                    }
                  />
                );
              })}
            </Box>
          </Box>
          <Formik
            initialValues={initialValues}
            enableReinitialize
            validationSchema={validate}
            onSubmit={(values) => {
              handleSubmit(values);
            }}
          >
            {(formik) => (
              <Form
                id="form_submit"
                onSubmit={formik.handleSubmit}
                style={{ marginTop: "1rem" }}
              >
                <InputField
                  fullWidth
                  variant="standard"
                  placeholder="Karst, Harald"
                  label={t("input-5")}
                  name="name"
                  type="text"
                />
                <InputField
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  variant="standard"
                  label={t("input-2")}
                  name="dateOfBirth"
                  type="date"
                  onKeyDown={handleDateOfBirthKeyDown}
                />
                <InputField
                  fullWidth
                  placeholder="Raithstr. 34 in 75417 Mühlacker"
                  variant="standard"
                  label={t("input-12")}
                  name="address"
                  type="text"
                />
                <InputField
                  fullWidth
                  placeholder="Harald1960@gmail.com"
                  variant="standard"
                  label={t("input-3")}
                  name="email"
                  type="email"
                />
                <InputField
                  fullWidth
                  placeholder="01774251960"
                  variant="standard"
                  label={t("input-4")}
                  name="phone"
                  type="string"
                  InputLabelProps={{ shrink: true }}
                />
              </Form>
            )}
          </Formik>
        </Box>
      )}
    </div>
  );
};

export default ReplacementAttorney;
